import { CheckOutlined, StopOutlined, MinusOutlined } from "@ant-design/icons";

export const textColor: Record<string, string> = {
  Complete: "#064C68",
  "Not Done": "#73134A",
  "Not Required": "#20353E",
  "Data Pending": "#3F3518",
  "Data Missing": "#A04000",
  "Data Discrepancy": "#980000",
};

export const pillColor: Record<string, string> = {
  Complete: "#D2EFF9",
  "Not Done": "#EBD1E0",
  "Not Required": "#D5DADC",
  "Data Pending": "#FEF7DF",
  "Data Missing": "#F2C9AE",
  "Data Discrepancy": "#F8CACA",
};

export const tooltipTitle: Record<string, string> = {
  Complete: "Activity occurred.",
  "Not Done": "Activity has not occurred.",
  "Not Required": "Activity is not expected to occur.",
  "Data Pending": "Data not yet available.",
  "Data Missing": "Expected data not found.",
  "Data Discrepancy": "Data mismatch.",
};

export const iconTypeMap: Record<string, React.ReactElement> = {
  Complete: <CheckOutlined style={{ color: "#064C68" }} />,
  "Not Done": <StopOutlined style={{ color: "#73134A" }} />,
  "Not Required": <MinusOutlined style={{ color: "#20353E" }} />,
  "-": <MinusOutlined style={{ color: "#556C75" }} />,
};
